import { rem, rgba } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import Button from "components/Button";
import { Ionicons } from "components/Icons";
import { themes } from "styles";

export const Partner = {
  Item: styled.div`
    padding: 12px;

    border-radius: 8px;
    border: 1px solid ${rgba(themes.palletes.primary, 0.3)};
    background-color: ${rgba(themes.palletes.primary, 0.02)};

    ${media.greaterThan("huge")`
      padding: 16px;
    `}
  `,

  Details: styled.div``,

  Title: styled.p`
    font-weight: 600;
    font-size: ${rem("11px")};
    color: ${themes.text.higher};

    ${media.greaterThan("huge")`
      font-size: ${rem("15px")};
    `}
  `,

  Description: styled.p`
    margin-top: 4px;

    font-size: ${rem("9px")};
    color: ${themes.text.high};

    ${media.greaterThan("huge")`
      font-size: ${rem("12px")};
    `}
  `,

  Actions: styled.div`
    margin-top: 8px;

    display: flex;

    ${media.greaterThan("huge")`
      margin-top: 16px;
    `}
  `,

  Action: styled(Button).attrs(() => ({
    size: "small",
    type: "button",
  }))`
    flex: 1;

    &:not(:last-of-type) {
      margin-right: 6px;
    }
  `,
};

export const Responsible = {
  Card: styled.div`
    padding: 32px;

    border-radius: 8px;
    border: 1px solid #edf3f5;
    box-shadow: 0 4px 4px ${rgba("#000", 0.01)};

    ${media.greaterThan("huge")`
      padding: 40px;
    `}
  `,

  Icon: styled(Ionicons)`
    color: ${themes.text.medium};
  `,

  Heading: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  Title: styled.p`
    display: flex;
    align-items: center;

    font-weight: 600;
    font-size: ${rem("11px")};
    color: ${themes.text.higher};

    ${media.greaterThan("huge")`
      font-size: ${rem("15px")};
    `}

    > div {
      margin-right: 8px;
    }
  `,

  Actions: styled.div``,

  Action: styled.button.attrs({
    type: "button",
  })`
    all: unset;

    cursor: pointer;
    font-weight: 600;
    font-size: ${rem("11px")};
    color: ${themes.palletes.primary};

    ${media.greaterThan("huge")`
      font-size: ${rem("15px")};
    `}

    &:not(:last-of-type) {
      margin-right: 16px;
    }

    &:hover {
      text-decoration: underline;
    }
  `,

  Body: styled.div`
    padding-top: 16px;
  `,

  Item: styled.div`
    font-size: ${rem("11px")};

    ${media.greaterThan("huge")`
      font-size: ${rem("15px")};
    `}

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  `,

  Label: styled.p`
    display: flex;
    align-items: center;

    color: ${themes.text.medium};

    > div {
      margin-right: 8px;
    }
  `,

  Value: styled.p`
    margin-top: 4px;
    padding-left: 20px;

    color: ${themes.text.higher};

    ${media.greaterThan("huge")`
      padding-left: 24px;
    `}
  `,
};
